import React, {useCallback, useMemo, useState} from 'react';
import ScenarioExecute from './ScenarioExecute';
import {DialogGeneric} from '../../../../core/dialog/DialogGeneric';
import styles from '../VisualizationScenarioAction.module.scss';
import {ScenarioActionProps} from '../../../actionMenuTypes';

export const useScenarioExecuteDialog = () => {
  const [openProps, setOpenProps] = useState<ScenarioActionProps>();
  const handleOnCancel = useCallback(() => {
    setOpenProps(undefined);
  }, []);
  const handleOnSuccess = useCallback(() => {
    setOpenProps(undefined);
    openProps?.onSuccess?.();
  }, [openProps]);

  const Component = useMemo(() => {
    return !openProps ? null : (
      <DialogGeneric open={true} title="Execute Instance" childrenAsText={false} includesDialogActions={true}>
        <div className={styles.dialog}>
          <ScenarioExecute
            model={openProps.model}
            subModel={openProps.subModel}
            scenario={openProps.scenario}
            onSuccess={handleOnSuccess}
            onCancel={handleOnCancel}
          />
        </div>
      </DialogGeneric>
    );
  }, [openProps, handleOnCancel, handleOnSuccess]);

  return {
    open: setOpenProps,
    Component,
  };
};
